import { render, staticRenderFns } from "./payOrderView.vue?vue&type=template&id=6b3f8d96&"
import script from "./payOrderView.vue?vue&type=script&lang=js&"
export * from "./payOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports